import { observable, action } from 'mobx';
import agent from '../agent';
import commonStore from './commonStore';
import dashboardStore from './dashboardStore';

//import websocketStore from './websocketStore';
//import { common } from '@material-ui/core/colors';
//import { convertColorToString } from 'material-ui/utils/colorManipulator';

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export class UserStore {
    @observable inProgress = false;
    @observable loginFailed = false;
    @observable statusText;
    @observable errors;
    @observable token;
    @observable user = {};
    @observable pwdTokenVerified;
    @observable updateProgress = false;
    @observable loginDetails = {
        email: '',
        password: '',
    };
    @observable registerFailed = false;
    @observable logoutSuccess = false;
    @observable logoutProgress = false;
    @observable emailVerified = false;
    @observable userList = [];
    @observable openAssignDialog = false;
    @observable userDetails = {};
    @observable changePasswordDialog = false;
    @observable userMenuArray = [];
    @observable isLocalTemplatePresent = false;
    @observable tempPic = undefined;
    @observable serverDown = false;
    @observable serverStatusProgress = false;

    constructor() {
        let userLocal = window.localStorage.getItem('user');
        if (userLocal) {
            userLocal = JSON.parse(userLocal);
            this.token = userLocal.token;
            this.user = userLocal.user;
            this.isLocalTemplatePresent = userLocal.isLocalTemplatePresent;
        }
    }
    @action setEmail(email) {
        this.loginDetails.email = email;
    }

    @action openDialog() {
        dashboardStore.closeFileActions();
        this.openAssignDialog = true;
    }

    @action closeDialog() {
        this.openAssignDialog = false
    }

    @action openChangePasswordDialog(value) {
        this.changePasswordDialog = value
    }

    @action setPassword(password) {
        this.loginDetails.password = password;
    }

    @action reset() {
        this.loginDetails.email = '';
        this.loginDetails.password = '';
    }

    @action handleFormChange(field, value) {
        if (this.user.userType !== 'AGENT')
            this.userDetails[`${field}`] = value
    }


    @action setLocalTemplate() {
        this.isLocalTemplatePresent = true;
        let userLocal = window.localStorage.getItem('user');
        if (userLocal) {
            userLocal = JSON.parse(userLocal);
            this.token = userLocal.token;
            this.user = userLocal.user;
            this.isLocalTemplatePresent = true
        }
        window.localStorage.setItem('user', JSON.stringify({
            user: this.user,
            token: this.token,
            isLocalTemplatePresent: this.isLocalTemplatePresent
        }));
    }

    @action login(email, password) {
        this.loginDetails.email = email;
        this.loginDetails.password = password;
        this.inProgress = true;
        this.loginFailed = false;
        this.errors = undefined;
        this.statusText = ''
        return agent.Auth.login(email, password)
            .then(action((response) => {
                if (response.statusCode === 200) {
                    this.user = response.userData.userDetails;
                    this.token = response.userData.accessToken;
                    this.isLocalTemplatePresent = response.userData.isLocalTemplatePresent;
                    if (this.token) {
                        window.localStorage.setItem('user', JSON.stringify({
                            user: this.user,
                            token: this.token,
                            isLocalTemplatePresent: this.isLocalTemplatePresent
                        }));
                    } else {
                        window.localStorage.removeItem('user');
                    }
                }
                else {
                    this.statusText = response.message;
                    this.loginFailed = true;
                }
            }))
            .catch(action((err) => {
                this.loginFailed = true;
                this.statusText = "Failed to login";
                if (err.response && err.response.status === 401) {
                    this.statusText = "Invalid credentials";
                }
                this.errors = err.response && err.response.body && err.response.body.errors;
                //throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action getServerStatus() {
        this.serverStatusProgress = true;
        this.serverDown = false
        return agent.Server.getServerStatus()
            .then(action((response) => {
                if (response) {
                    let temp = JSON.parse(response)
                    if (!temp.status)
                        this.serverDown = true
                }


            }))
            .catch(action((err) => {

            }))
            .finally(action(() => { this.serverStatusProgress = false; }));
    }


    @action register(newUser) {
        this.inProgress = true;
        this.registerFailed = false;
        this.errors = undefined;
        return agent.Auth.register(newUser)
            .then(action((response) => {
                if (response.statusCode !== 200) {
                    this.registerFailed = true;
                    this.statusText = response.message;
                    commonStore.handleOpenSnackBar(response.message, 'error')
                }
                else {
                    this.statusText = response.message;
                }

            }))
            .catch(action((err) => {
                this.registerFailed = true;
                this.statusText = "Registration Failed";
                commonStore.handleOpenSnackBar("Registration Failed! ", 'error')
            }))
            .finally(action(() => { this.inProgress = false; }));
    }



    @action verifyEmail(token) {
        this.inProgress = true;
        this.statusText = '';
        return agent.Auth.verifyEmail(token)
            .then(action((response) => {
                if (response.statusCode === 200) {
                    this.emailVerified = true;
                    commonStore.handleOpenSnackBar(response.message, 'success')
                }
                else {
                    this.statusText = response.message;
                    commonStore.handleOpenSnackBar(response.message, 'error')
                }
            }))
            .catch(action((err) => {
                this.token = undefined;
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action verifyUpdatedEmail(token) {
        this.statusText = '';
        return agent.Auth.verifyUpdatedEmail(token)
            .then(action((response) => {
                if (response.statusCode === 200) {
                    this.emailVerified = true;
                    commonStore.handleOpenSnackBar(response.message, 'success')
                }
                else {
                    this.statusText = response.message;
                    commonStore.handleOpenSnackBar(response.message, 'error')
                }

            }))
            .catch(action((err) => {
                this.token = undefined;
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action logout() {
        this.logoutSuccess = false;
        this.logoutProgress = true;
        return agent.Auth.logout()
            .then(action((response) => {
                this.logoutSuccess = true;
                this.token = undefined;
                window.localStorage.removeItem("user")
                this.goToLogin()
            }))
            .catch(action((err) => {
                this.token = undefined;
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.logoutProgress = false;
                this.logoutSuccess = true;
                this.token = undefined;
                window.localStorage.removeItem("user")
            }));
    }

    @action requestPasswordReset(email) {
        this.inProgress = true;
        this.statusText = ''
        return agent.Auth.requestPasswordReset(email)
            .then(action((response) => {
                if (response.statusCode !== 200)
                    this.statusText = response.message;
                else {
                    commonStore.handleOpenSnackBar("Password reset email sent to your registered mail ID.", "info")

                }

            }))
            .catch(action((err) => {
                this.token = undefined;
                this.errors = err.response && err.response.body && err.response.body.errors;

            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action resetPassword(token, password) {
        this.inProgress = true;
        this.statusText = ''
        return agent.Auth.resetPassword(token, password)
            .then(action((response) => {
                if (response.statusCode === 200) {
                    this.pwdTokenVerified = true;
                    commonStore.handleOpenSnackBar(response.message, 'success')
                }
                else
                    commonStore.handleOpenSnackBar(response.message, 'error')
            }))
            .catch(action((err) => {
                this.pwdTokenVerified = false;
                this.token = undefined;
                commonStore.handleOpenSnackBar('Password reset failed!', 'error')
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action updateEmailResetPassword(token, password) {
        this.inProgress = true;
        this.statusText = ''
        return agent.Auth.updateEmailResetPassword(token, password)
            .then(action((response) => {
                if (response.statusCode === 200) {
                    this.pwdTokenVerified = true;
                    commonStore.handleOpenSnackBar(response.message, 'success')
                }
                commonStore.handleOpenSnackBar(response.message, 'error')
            }))
            .catch(action((err) => {
                this.pwdTokenVerified = false;
                this.token = undefined;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }


    @action verifyPasswordToken(token) {
        this.inProgress = true;
        return agent.Auth.verifyPasswordToken(token)
            .then(action((response) => {
                this.pwdTokenVerified = true
            }))
            .catch(action((err) => {
                this.token = undefined;
                this.errors = err.response && err.response.body && err.response.body.errors;
                this.pwdTokenVerified = false;
                throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action changePassword(currentPassword, newPassword) {
        this.inProgress = true;
        return agent.User.changePassword(currentPassword, newPassword)
            .then(action((response) => {
                if (response.statusCode == "200") {
                    this.openChangePasswordDialog(false)
                    commonStore.handleOpenSnackBar(response.message, 'success')
                }
                else {
                    commonStore.handleOpenSnackBar(response.message, 'error')
                }
            }))
            .catch(action((err) => {

            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action validateEmail(email) {
        if (!email || !emailRegex.test(email))
            return false;
        return true;
    }

    @action goToLogin() {
        this.token = undefined;
        window.localStorage.removeItem("user");
        window.location.reload();
    }

    @action getUserList(assignFlag) {
        //this.inProgress = true;
        this.errors = undefined;
        return agent.User.getUserList(assignFlag)
            .then(action((response) => {
                if (response.statusCode == 200) {
                    this.userList = response.data.userList;
                    this.totalUsers = response.data.totalUsers
                    this.resetUserMenuArray()
                }
            }))
            .catch(action((err) => {
                this.registerFailed = true;
                this.statusText = "Registration Failed";
                this.errors = err.response && err.response.body && err.response.body.errors;
                //throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action getUserDetails() {
        this.inProgress = true;
        this.errors = undefined;
        return agent.User.getUserDetails(this.user._id)
            .then(action((response) => {
                if (response.statusCode == "200") {
                    this.userDetails = response.data;
                    this.tempPic = this.userDetails.profilePic
                }
            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action setProfilePic(img) {
        this.userDetails.profilePic = img
    }

    @action uploadProfilePicture(img) {
        this.inProgress = true;
        this.errors = undefined;
        return agent.User.uploadProfilePicture(img)
            .then(action((response) => {
                if (response.statusCode == "200") {
                    this.user.profilePic = this.userDetails.profilePic
                    window.localStorage.setItem('user', JSON.stringify({
                        user: this.user,
                        token: this.token
                    }));
                }
            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action assignDocuments(assignTo) {
        let temp = []
        if (dashboardStore.currentId !== undefined)
            temp.push(dashboardStore.currentId)
        else
            for (let i = 0; i < dashboardStore.selectedDocs.length; i++) {
                if (dashboardStore.selectedDocs[i])
                    temp.push(dashboardStore.documentList[i]._id)
            }
        this.inProgress = true;
        this.errors = undefined;
        let index = this.userList.findIndex(x => x.email === assignTo.split(",")[1])
        let assignId = this.userList[index]._id
        return agent.User.assignDocuments(temp, assignId)
            .then(action((response) => {
                dashboardStore.closeFileAssignDialog();
                dashboardStore.resetSelectedDocuments();
                if (this.user.userType === 'SUPER_ADMIN')
                    dashboardStore.sortDocumentList('REVIEW_PENDING', 'createdAt', -1)
                else
                    dashboardStore.getHomePageData('createdAt', -1);
                this.closeDialog()
                if (response.statusCode == 200)
                    commonStore.handleOpenSnackBar("Files assigned to user successfully!", "success")
                else
                    commonStore.handleOpenSnackBar(response.message, "error")
            }))
            .catch(action((err) => {
                this.registerFailed = true;
                commonStore.handleOpenSnackBar("File assignment unsuccessful!", "error")
            }))
            .finally(action(() => { this.inProgress = false; }));
    }


    @action updateUserSettings = (img) => {
        this.updateProgress = true;
        this.statusText = '';
        let temp = {}
        temp.userFullName = this.userDetails.userFullName;
        temp.email = this.userDetails.email;
        temp.department = this.userDetails.department;
        temp.domain = this.userDetails.domain;
        temp.mobileNumber = this.userDetails.mobileNumber;
        let temp1 = this.userDetails.profilePic;
        if (img !== undefined) {
            this.uploadProfilePicture(img)
        }
        return agent.User.updateUserSettings(temp)
            .then(action((response) => {
                if (response.statusCode === 200) {
                    this.userDetails = response.userData;
                    this.userDetails.profilePic = temp1
                    this.user.userFullName = this.userDetails.userFullName;
                    this.user.email = this.userDetails.email;
                    this.user.profilePic = temp1
                    window.localStorage.setItem('user', JSON.stringify({
                        user: this.user,
                        token: this.token
                    }));
                    commonStore.handleOpenSnackBar(response.message, "success")
                }
                else {
                    commonStore.handleOpenSnackBar(response.message, "error")
                }

            }))
            .catch(action((err) => {
                this.token = undefined;
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }))
            .finally(action(() => { this.updateProgress = false; }));
    }


}

export default new UserStore();
